module.exports = __webpack_public_path__ + "img/crelogo.368e473e.svg";